import React from "react";
import {Navigate, useRoutes} from "react-router";
import ListOfExperts from "../features/experts/ListOfExperts.jsx";
import ExpertPage from "../features/experts/ExpertPage";
import ReportPreviewPage from "../features/products/previewPage/ReportPreviewPage";
import AppReviewer from "../apps/reviewer/appReviewer";
import ListOfReports from "../apps/reviewer/pages/ListOfReports/ListOfReports";
import ProductPage from "../apps/reviewer/pages/product/ProductPage";
import {routesChat} from "./routesChat";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import IcrPage from "../features/collection-requests/IcrPage";
import NewIcrPage from "../features/collection-requests/NewIcrPage.jsx";
import EeiPage from "../features/collection-requests/EeiPage";
import GapPage from "../features/collection-requests/GapPage";
import ListOfIntCollRequests from "../features/collection-requests/ListOfIntCollRequests";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import HelpPage from "../features/help/HelpPage";
import WorkflowPage from "../features/workflow/WorkflowPage";
import DisclosureReviewSplitPage
    from "../apps/disclosure_officer/pages/DisclosureReviewSplitPage/DisclosureReviewSplitPage";
import LegacyRfiRedirect from "./LegacyRfiRedirect";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import TagBrowsePage from "../features/collection-requests/tags/TagBrowsePage";
import {collectionDeepLinkRoutes} from "./collectionRoutes";

const routesReviewer = [
    ...routesChat,
    {
        path: "/",
        element: <AppReviewer/>,
        children: [
            {index: true, element: <Navigate to="products" replace/>},
            {path: "products", element: <ListOfReports/>},
            {path: "/icr/eei/:eeiNumber", element: <EeiPage/>},
            {path: "/icr/gap/:gapNumber", element: <GapPage/>},
            {path: "/icr/new", element: <NewIcrPage/>},
            {path: "/icr/:icrNumber", element: <IcrPage/>},
            {path: "/icr", element: <ListOfIntCollRequests/>},
            {path: "/tags/:tag", element: <TagBrowsePage/>},
            {path: "/rfi", element: <Navigate to="/icr" replace/>},
            {path: "/rfi/*", element: <LegacyRfiRedirect/>},
            ...collectionDeepLinkRoutes,
            {path: "charts", element: <WhiteboardsListPage/>},
            {path: "experts", element: <ListOfExperts/>},
            {path: "experts/:handle", element: <ExpertPage/>},
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
            {path: "help", element: <HelpPage/>},
            {path: "workflow", element: <WorkflowPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
        ],
    },
    {
        path: "/products/:reportId",
        // element: <ReportEditorPage/>,
        element: <ProductPage/>,
        children: [
            {path: "preview", element: <ReportPreviewPage/>},
            {path: "preview/:version", element: <ReportPreviewPage/>},
            {index: true, element: <Navigate to="preview" replace/>},
        ],
    },
    {
        path: "/disclosures/:reportId",
        element: <DisclosureReviewSplitPage backPath="/products"/>,
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/products" replace/>},
];

export function RoutesReviewer() {
    return useRoutes(routesReviewer);
}
